import { render, staticRenderFns } from "./OutReachClientsWithMostOpens.vue?vue&type=template&id=15b3e832&scoped=true&"
import script from "./OutReachClientsWithMostOpens.vue?vue&type=script&lang=js&"
export * from "./OutReachClientsWithMostOpens.vue?vue&type=script&lang=js&"
import style0 from "./OutReachClientsWithMostOpens.vue?vue&type=style&index=0&id=15b3e832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3e832",
  null
  
)

export default component.exports